import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const FinancialBillingIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-[18px] w-[18px] shrink-0", className)}
      viewBox="0 0 18 18"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M9 18C13.9627 18 18 13.9627 18 9C18 4.03725 13.9627 0 9 0C4.03725 0 0 4.03725 0 9C0 13.9627 4.03725 18 9 18ZM9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 13.1355 13.1355 16.5 9 16.5C4.8645 16.5 1.5 13.1355 1.5 9C1.5 4.8645 4.8645 1.5 9 1.5ZM6 7.5C6 6.2595 7.0095 5.25 8.25 5.25V4.5C8.25 4.08525 8.58525 3.75 9 3.75C9.41475 3.75 9.75 4.08525 9.75 4.5V5.25H9.951C10.7512 5.25 11.4983 5.6805 11.8995 6.37425C12.1073 6.7335 11.9843 7.19175 11.6265 7.39875C11.2673 7.608 10.8082 7.4835 10.602 7.12575C10.4677 6.89325 10.2188 6.75 9.95175 6.75H8.25075C7.83675 6.75 7.50075 7.086 7.50075 7.5C7.50075 7.7835 7.704 8.0235 7.98375 8.07L10.2645 8.45025C11.271 8.6175 12.0008 9.48 12.0008 10.5C12.0008 11.7405 10.9913 12.75 9.75075 12.75V13.5C9.75075 13.914 9.4155 14.25 9.00075 14.25C8.586 14.25 8.25075 13.914 8.25075 13.5V12.75H8.04975C7.2495 12.75 6.5025 12.3187 6.10125 11.625C5.8935 11.2665 6.0165 10.8082 6.37425 10.6005C6.73425 10.3927 7.1925 10.5157 7.39875 10.8742C7.533 11.106 7.782 11.2492 8.049 11.2492H9.75C10.164 11.2492 10.5 10.9125 10.5 10.4992C10.5 10.2157 10.2968 9.97575 10.017 9.92925L7.73625 9.549C6.72975 9.38175 6 8.51925 6 7.49925V7.5Z"
      fill={fill}
    />
    </svg>
  );
};

export default FinancialBillingIcon;
